import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getSignupUrl } from 'LoginUI/utils/urls';
import { trackSignupLinkClick } from 'LoginUI/lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SignUpLink = ({
  isFbSignin,
  signupParams,
  loginRedirectUrlQueryParam,
  pageId
}) => {
  const signupUrl = getSignupUrl(signupParams, isFbSignin, pageId, loginRedirectUrlQueryParam);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.signupLink.text"
    }), /*#__PURE__*/_jsx(Link, {
      onClick: () => trackSignupLinkClick('control'),
      href: signupUrl,
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.signupLink.cta"
      })
    })]
  });
};
export default SignUpLink;